/**
 * NotesPanel Component - MA-ARCH-161
 * 
 * Extracted from ScriptPlay.jsx - Notes panel for the Quick Reference side panel.
 * Simple textarea for run notes.
 */

import React from 'react';
import { CardContent } from '@/components/ui/card';
import { Textarea } from '@/components/ui/textarea';

/**
 * @param {Object} props
 * @param {string} props.value - Current notes text
 * @param {Function} props.onChange - Callback when text changes: (text: string) => void
 */
export function NotesPanel({ value, onChange }) {
  return (
    <CardContent
      className="min-h-0 flex-1 overflow-y-auto pt-4"
      data-testid="quick-reference-notes"
    >
      <div className="space-y-3">
        <Textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Type notes for this run..."
          className="min-h-[260px] bg-white/5 text-slate-100 ring-1 ring-white/10"
          data-testid="quick-reference-notes-textarea"
        />
        <div className="text-xs text-slate-200/70">
          Auto-saved for this run.
        </div>
      </div>
    </CardContent>
  );
}

export default NotesPanel;
